export enum CheckQualificationResponseType {
  Redirect = 1,
  Client = 2,
  Success = 3,
  LinkedIn = 4,
  Routed = 5,
  MBDGoogleStart = 6
}
